import { computed, type ComputedRef } from 'vue'
import { useLocalStorage } from '@gat-ship/utils'
import { dedupeRecentSearches, type RecentSearch } from '../model/recent-search'

export type { RecentSearch }

// Key predates the global-search rebuild — keep it so existing users
// retain their recent-search history.
export const RECENT_SEARCHES_STORAGE_KEY = 'gs-recent-searches'

const MAX_STORED_RECENT_SEARCHES = 10

export interface RecentSearchStore {
  /** Stored recent searches, newest first. */
  recentSearchItems: ComputedRef<RecentSearch[]>
  /** Adds a search, deduped by (query, context), capped at {@link MAX_STORED_RECENT_SEARCHES}. */
  addRecentSearch: (search: RecentSearch) => void
}

export function createRecentSearchStore(): RecentSearchStore {
  const storedSearches = useLocalStorage<RecentSearch[]>(
    RECENT_SEARCHES_STORAGE_KEY,
    []
  )

  const recentSearchItems = computed(() => storedSearches.value)

  function addRecentSearch(search: RecentSearch) {
    storedSearches.value = dedupeRecentSearches(
      storedSearches.value,
      search,
      MAX_STORED_RECENT_SEARCHES
    )
  }

  return { recentSearchItems, addRecentSearch }
}
